<template>
  <div>
    <!-- Structured Data (JSON-LD) for SEO -->
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "엠포컴퍼니",
      "alternateName": ["M4 Company", "M4", "엠포"],
      "url": "https://m-4.co.kr",
      "logo": "https://m-4.co.kr/logo_white.png",
      "description": "엠포(M4 Company)는 RAG, Fine-Tuning 기술을 기반으로 하이브리드 융합 지식 AI서비스를 제공합니다. 또한 3D실내지도, RTLS, IoT를 활용하여 정밀한 스마트 공간 운영 및 위치 기반 서비스를 구축합니다.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "성수아카데미타워 624호",
        "addressLocality": "성동구",
        "addressRegion": "서울특별시",
        "addressCountry": "KR"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+82-70-8844-0621",
        "contactType": "customer service",
        "email": "info@m-4.co.kr"
      },
      "sameAs": [
        "https://play.google.com/store/apps/details?id=com.m4.mind",
        "https://apps.apple.com/us/app/id1584318132"
      ]
    }
    </script>
    <div>
      <div class="header_margin">      
      </div>    
    </div>
    <div align="center" justify="center">      
      <div class="text-center" id="blinking">
        <h2 id="typing-demo" class="white--text mt-8 mb-1  font-weight-light"></h2>
        <img                    
          src="../assets/logo_white.png"           
          width="300px"          
        />
      </div>      
      
    </div>
    
    <div>
      
      <div class="header_margin">
      </div>
      <div class="text-right" style="position: relative; width:100%; right:10px; color : #ffffffe0; font-size: 12px; font-weight: 300; ">이 사이트에서 사용된 이미지는 AI기술을 사용하여 만들어졌습니다.</div>
    </div>    



    <div id="scoll_About" align="center" justify="center" >      
      <div class="mt-10">
        <div class="title_caption">ABOUT</div>
        <div class="title_header">M4 company</div>
        <div class="title_sub">AI로 기업의 경쟁력을 생성합니다.</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/about.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            AI로 지식가치와 공간가치를 <br>
            생성하는 기업 
          </div>
          <div class="content_caption text-left mt-4">
            M4 Company는 RAG 최적화 기술과 도메인 특화 파인튜닝을 결합하여, 기업 환경에 특화된 가장 정확하고 신뢰도 높은 GenAI 서비스를 제공합니다.<br>
            또한 AI기반 3D 지도 생성 솔루션, RTLS, IoT 등의 핵심 기술을 보유하고 있으며, <span @click="OpenImageNewWindow()" style="color:blue; cursor:pointer">트리플윈</span>의 관계 지향으로 회사와 고객, 또한 모두에게 유익하고 지속가능한 가치를 창출해 나가고 있습니다.
          </div>
        </div>
      </div>
      <!-- 반응형, 크기가 작을 때 -->
      <div class="ma-5 hidden-sm-and-up" style="">                            
        <img                              
          src="../assets/value_ko.svg"           
          width="320px"/>                            
      </div>
      <!-- 반응형, 일반 화면 -->
      <div class="ma-5 hidden-xs-only" style="">                            
        <img                              
          src="../assets/value_ko.svg"           
          width="400px"/>                            
      </div>
      
    </div>


    <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-10">
        <div class="title_caption">SOLUTION #1</div>
        <div class="title_header">OdyMAP</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/odymap_logo.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            3D 실내지도 생성 툴 / 뷰어
          </div>
          <div class="content_caption text-left mt-4">
            OdyMAP은 웹 환경에서 건축용 CAD 도면(CAD파일 or 이미지파일)을 이용하여 누구나 빠르고 쉽게 3D 실내지도를 생성할 수 있는 툴을 제공합니다. 
						실내지도를 광범위하게 구축함으로써 다양한 산업 분야에 실내지도 데이터를 제공할 수 있습니다. 
						향후 건물주에게는 소유권을, 지도 제작자에게는 저작권을 NFT로 발행하고 수익의 일부를 공유하여 새로운 비즈니스를 만들 계획입니다.
          </div>
          <div class="content_caption text-left mt-4">
            Demo viewer: <a href="https://ody.m-4.co.kr/#/MapView?BuildingId=1001&GroupId=1001" target="_blank">https://ody.m-4.co.kr/#/MapV...</a>
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                            
          <div class="image_title pa-3"><div>3D 지도 도구</div></div>
          <img                              
            src="../assets/sol_01.jpg"           
            width="200px"/>                                    
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">3D 지도 뷰어</div>
          <img                              
            src="../assets/sol_02.jpg"           
            width="200px"/>                                    
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">경로 찾기</div>
          <img                              
            src="../assets/sol_03.jpg"           
            width="200px"/>                                    
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">
            <div class="pt-3">IPS<p class="caption">(Indoor Positioning System)</p></div>
          </div>
          <img                              
            src="../assets/sol_04.jpg"           
            width="200px"/>                                    
        </div>        
      </div>
    </div>

    <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SOLUTION #2</div>
        <div class="title_header">M.RTLS</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img    
            class="img_outline"                          
            src="../assets/rtls.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            보안 및 안전관리를 위한<br>
						실시간 통제, 관리시스템
          </div>
          <div class="content_caption text-left mt-4">
            보안, 안전관리가 필요한 지역에 인가된 인원만 출입할 수 있도록 관리하는 출입통제시스템과 안전관리를 위한 실시간 IoT센서 관리시스템(가스, 소음, 진동, 날씨, 장비, 인력 등)을 제공합니다. 
						3D 실내지도와 실내 측위기술을 기반으로 실시간 출입관리 서비스(비상호출기능 포함)를 제공하며 구역별 체류시간과 출입이력을 체계적으로 관리합니다.
          </div>
          <div class="content_caption text-left mt-4">
            Demo site: <a href="https://rtls.m-4.co.kr/#/Login" target="_blank">https://rtls.m-4.co.kr</a><br>
            (ID: guest / PW: niceday777)
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                            
          <div class="image_title pa-3"><div>실시간 출입통제 / 긴급호출</div></div>
          <div class="image_title" style="width: 300px; height: 200px; background-color: #ffffff;">
            <img                              
            src="../assets/sol_11.jpg"           
            width="300px"/>                                      
          </div>

          
        </div>
        <div class="ma-3">                            
          <div class="image_title pa-3">IoT 센서 관리</div>
          <div class="image_title" style="width: 300px; height: 200px; background-color: #ffffff;">
            <img                              
            src="../assets/sol_12.jpg"           
            width="300px"/>                                      
          </div>
        </div>
        
      </div>
    </div>


    <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SOLUTION #3</div>
        <!-- 반응형, 크기가 작을 때 -->
        <div class="title_header2 hidden-sm-and-up" style="width:300;">M.blockchain</div>
        <!-- 반응형, 일반 화면 -->
        <div class="title_header hidden-xs-only" style="width:300;">M.blockchain</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" >                            
          <img 
            class="img_outline"
            src="../assets/blockchain.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            DPOS 기반 블록체인 메인넷 
          </div>
          <div class="content_caption text-left mt-4">
            200 TPS를 구현하고 스마트 계약을 제공하는 DPOS 기반의 블록체인 메인넷입니다.
            <img class="img"
            src="../assets/blockchain2.png"           
            width="300px"/>                                      
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                            
          <div class="image_title pa-3">메인넷</div>
          <div class="image_title" style="height: 220px; background-color: #ffffff;">
            <img                              
            src="../assets/sol_31.jpg"           
            width="300px"/>                                      
          </div>
        </div>  
        <div class="ma-3">                            
          <div class="image_title pa-3">트레이딩 아키텍처</div>
          <div class="image_title" style="height: 220px; background-color: #ffffff;">
            <img                              
            src="../assets/mainnet2.png"           
            width="300px"/>                                      
          </div>
        </div>              
      </div>      
    </div>


    <!-- <div class="mt-5" id="scoll_Solution" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SOLUTION #4</div>
        <div class="title_header2 hidden-sm-and-up" style="width:300;">GattyAI</div>
        <div class="title_header hidden-xs-only" style="width:300;">GattyAI</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" >                            
          <img 
            class="img_outline"
            src="/gattyAI_logo.svg"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            RAG·파인튜닝 하이브리드 융합 지식 <br>
            AI 서비스
          </div>
          <div class="content_caption text-left mt-4">
            GattyAI는 LLM 기반 대형 언어 모델을 도메인별 데이터로 정교하게 파인튜닝하고, 벡터 DB를 활용한 RAG 파이프라인을 결합한 하이브리드 지식 AI 플랫폼입니다. 모델 내부 지식과 실시간 검색 정보를 통합해 최신·정확·근거 기반 응답을 제공하며, 모든 컴포넌트를 컨테이너화해 온프레미스·클라우드 어디서나 안전하게 확장·배포할 수 있습니다. 지속적 데이터 업데이트와 피드백 루프로 성능을 자동 고도화하며, 도입 시 고품질 자동화 상담·지식 자산 활용 극대화·운영 비용 절감을 동시에 달성하실 수 있습니다.
          </div>
        </div>
      </div>
      
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3">                                      
          <div class="image_title" style="height: 500px; background-color: #ffffff;">
            <img src="/gattyAI_architecture.svg" style="width: 90%;"/>                                      
          </div>
        </div>          
      </div>      
    </div> -->


    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #1</div>
        <div class="title_header">MIND</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/mind2.png"           
            width="220px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            108배 카운터
          </div>
          <div class="content_caption text-left mt-4">
            MIND는 더 밝고, 더 선명하고, 더 빛나는 세상을 만들겠다는 M4Company의 사명으로 만들어진 앱입니다. 
						MIND 앱은 카운터 기능과 운동(108배)하는 여러분을 도울 수 있는 명상 음악을 제공합니다. 
						또한 사용자들에게 유용한 정보를 공유하기 위해 게시판을 운영하고 있습니다.
          </div>
          <div class="mt-10">
            <h1 class="black--text">MIND 다운로드</h1>          
            <div>
							MIND 앱은 절, 명상을 도와줄 수 있는<br>
							카운트, 음악, 타이머를 제공합니다.<br>
							무료로 플레이하세요
						</div>
            <div>
              <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=com.m4.mind" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>
              <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1584318132" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>         
            </div>
          </div>
        </div>
      </div>
    </div>


    
    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #2</div>
        <div class="title_header">M4Tarot</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/tarot.png"           
            width="220px"/>                            
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            AI 기반의 타로 카드
          </div>
          <div class="content_caption text-left mt-4">
            AI 기술을 기반으로 생성된 이미지를 사용하고 LLM을 이용하여 선별된 타로 카드에 대해 상담합니다.<br><br>
            - AI로 생성된 이미지<br>
            - 생성형 AI(LLM)<br>
            - 파인튜닝(Fine-tuning)
          </div>
          <div class="mt-10">
            <h1 class="black--text">M4Tarot 다운로드</h1>          
            <div>타로 카드를 무료로 즐기세요.</div>
            <div>
              <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=com.m4.app_tarot&pli=1" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>
              <!-- <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1584318132" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>          -->
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #3</div>
        <div class="title_header">EPITAPH</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <!-- 반응형, 크기가 작을 때 -->
        <div class="ma-3 hidden-sm-and-up" style="">                            
            <video controls width="300px" poster="../assets/EPITAPH_poster.png">
              <source src="../assets/EPITAPH.mp4" type="video/mp4">
            </video>
        </div>
        <!-- 반응형, 일반 화면 -->
        <div class="ma-3 hidden-xs-only" style="">                            
            <video controls width="560px" poster="../assets/EPITAPH_poster.png">
              <source src="../assets/EPITAPH.mp4" type="video/mp4">
            </video>
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            디지털 추모공간<br>
            (AI기술 기반)
          </div>
          <div class="content_caption text-left mt-4">
            AI기술을 활용하여 가치 있고 아름다운 추모 공간을 만듭니다.<br>
            - AI 고인 캐릭터 생성<br>
            - AI 고인 캐릭터와의 대화(fine-tuning)<br>
            - 고인을 추모하는 디지털 추모공간 제공<br>
						&nbsp;&nbsp;&nbsp;(사진, 목소리, 에피소드 등)<br>
            - 부고알림
          </div>
          <div class="content_caption text-left mt-4">
            <a href="https://epitaph.m-4.co.kr" target="_blank">https://epitaph.m-4.co.kr</a>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-5" id="scoll_Service" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">SERVICE #4</div>
        <div class="title_header">Ticchettio</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex;">
        <!-- 반응형, 크기가 작을 때 -->
        <div class="ma-3 mt-10 hidden-sm-and-up">                            
            <iframe width="300" height="166" src="https://www.youtube.com/embed/dnvBE-UyAxg?si=z93NQWVF-rJIiaB4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <!-- 반응형, 일반 화면 -->
        <div class="ma-3 mt-10 hidden-xs-only">                            
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dnvBE-UyAxg?si=z93NQWVF-rJIiaB4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            AI, 채팅, 이미지 생성
          </div>
          <div class="content_caption text-left mt-4">
            티케티오는 사용자를 위해 새로운 디지털 친구를 만들고 개인화된 콘텐츠를 제공하는 AI 기반 서비스입니다.<br><br>
            - 사용자의 취향, 관심사, 성향을 반영하도록 설계된 사용자의 입력을 기반으로 독특한 캐릭터를 만듭니다. 사용자는 자신이 만든 캐릭터나 이미 만들어진 관심사 캐릭터와 채팅을 할 수 있습니다.<br>
            - 생성된 AI 캐릭터는 그들만의 짧은 비디오와 블로그를 만듭니다. 캐릭터의 특성에 맞추기 위해 AI기술을 사용하여 콘텐츠와 이미지를 만듭니다.<br>
            - AI를 사용하여 이미지와 개인 블로그를 만들고 공유하는 기능을 제공합니다. 사용자는 자신이 만든 콘텐츠를 다른 사람들과 공유함으로써 경험해보지 못한 색다른 즐거움을 느낄 수 있습니다.
          </div>
          <div class="mt-10">
            <div>
              <v-btn class="ma-2" outlined color="black" href="https://play.google.com/store/apps/details?id=com.m4.app_Ticchettio" target="_blank"><v-icon class="mr-1" >mdi-google-play</v-icon>GOOGLE PLAY</v-btn>
              <!-- <v-btn class="ma-2" outlined color="black" href="https://apps.apple.com/us/app/id1584318132" target="_blank"><v-icon class="mr-1">mdi-apple</v-icon>APP STORE</v-btn>          -->
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-5" id="scoll_History" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">HISTORY</div>
        <div class="title_header">M4 Company</div>
        <!-- <div class="title_sub">Digital transformation of all indoor spaces in the world.</div> -->
      </div>        

      <!-- 반응형, 크기가 작을 때 -->
      <div class="text-left hidden-sm-and-up" style="width:300px;">
        <v-timeline dense>
          <v-timeline-item color="blue">
            <div class="content_header" style="font-size: 40px;">2025</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >17-Sep</v-chip>'H사 채용홈페이지' 개발 납품</div>            
          </v-timeline-item>
          <!-- <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >21-Jun</v-chip>'Gatty AI 서비스 개시 (RAG, 파인튜닝 하이브리드 AI서비스)</div>            
          </v-timeline-item> -->
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >17-Mar</v-chip>'클라우드 기반 소방통합 누리집' 개발 납품</div>            
          </v-timeline-item>  
          <v-timeline-item color="blue darken-1">
            <div class="content_header" style="font-size: 40px;">2024</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-1" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >27-Nov</v-chip>'S사 인력관리 솔루션' 개발 납품</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-1" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>'실내 3D 도면 생성을 위한 백터 이미지 생성 방법 및 이를 이용한 실내 3D 도면 생성방법' 특허등록 (제10-2732289호)</div>            
          </v-timeline-item>          
          <v-timeline-item color="blue darken-2">
            <div class="content_header" style="font-size: 40px;">2023</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >08-Dec</v-chip>티케티오 서비스 개시</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >03-Dec</v-chip>첨단재난대응디지털플랫폼 개발 납품</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>애피탑 서비스 개시</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >30-Jun</v-chip>방문예약시스템 개발 납품</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Mar</v-chip>대표이사 변경(최원혁)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Feb</v-chip>긴급호출시스템 개발 납품(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3">
            <div class="content_header" style="font-size: 40px;">2022</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >31-May</v-chip>출입통제시스템 개발 납품(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Dec</v-chip>자본금 증자(3.5억원)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >02-Jan</v-chip>OdyMAP 개발 착수</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4">
            <div class="content_header" style="font-size: 40px;">2021</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>본사 사무실 이전 및 사명변경(주식회사 엠포컴퍼니)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>MIND앱 개발, 서비스 개시</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >14-Jun</v-chip>회사설립(주식회사 엠포, 자본금 1억)</div>            
          </v-timeline-item>
        </v-timeline>
      </div>
      
      <!-- 반응형, 일반 화면 --> 
      <div class="text-left hidden-xs-only" style="width:1000px;">
        <v-timeline dense>
          <v-timeline-item color="blue">
            <div class="content_header" style="font-size: 40px;">2025</div>            
          </v-timeline-item>
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >17-Sep</v-chip>'H사 채용홈페이지' 개발 납품</div>            
          </v-timeline-item>
          <!-- <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >21-Jun</v-chip>'Gatty AI 서비스 개시 (RAG, 파인튜닝 하이브리드 AI서비스)</div>            
          </v-timeline-item> -->
          <v-timeline-item color="blue" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >17-Mar</v-chip>'클라우드 기반 소방통합 누리집' 개발 납품</div>            
          </v-timeline-item>   
          <v-timeline-item color="blue darken-1">
            <div class="content_header" style="font-size: 40px;">2024</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-1" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >27-Nov</v-chip>'S사 인력관리 솔루션' 개발 납품</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-1" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>'실내 3D 도면 생성을 위한 백터 이미지 생성 방법 및 이를 이용한 실내 3D 도면 생성방법' 특허등록 (제10-2732289호)</div>            
          </v-timeline-item>            
          <v-timeline-item color="blue darken-2">
            <div class="content_header" style="font-size: 40px;">2023</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >08-Dec</v-chip>티케티오 서비스 개시</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >03-Dec</v-chip>첨단재난대응디지털플랫폼 개발 납품</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >15-Nov</v-chip>애피탑 서비스 개시</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >30-Jun</v-chip>방문예약시스템 개발 납품</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Mar</v-chip>대표이사 변경(최원혁)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-2" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Feb</v-chip>긴급호출시스템 개발 납품(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3">
            <div class="content_header" style="font-size: 40px;">2022</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >31-May</v-chip>출입통제시스템 개발 납품(RTLS)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >12-Dec</v-chip>자본금 증자(3.5억원)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-3" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >02-Jan</v-chip>OdyMAP 개발 착수</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4">
            <div class="content_header" style="font-size: 40px;">2021</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>본사 사무실 이전 및 사명변경(주식회사 엠포컴퍼니)</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >28-Jul</v-chip>MIND앱 개발, 서비스 개시</div>            
          </v-timeline-item>
          <v-timeline-item color="blue darken-4" small>
            <div class="content_caption" style="font-size: 15px;"><v-chip label class="mr-2 mt-n1" small >14-Jun</v-chip>회사설립(주식회사 엠포, 자본금 1억)</div>            
          </v-timeline-item>
        </v-timeline>
      </div>

    </div>


    <div class="mt-5" id="scoll_Contact" align="center" justify="center" >            
      <div style="height: 30px;"></div>
      <div class="mt-15">
        <div class="title_caption">CONTACT</div>
        <div class="title_header">Contact M4 Company</div>
        
      </div>        
      <v-container fluid>
        <div
          class="flex"        
          flat        
          color="white"
        >
          <v-row
            class="ma-0"
            color="white"              
            align="center"              
            justify="center"                            
          >
            <div id="item-box3" class="ma-3 pa-3 black--text">        
              <div>(주)엠포컴퍼니<br></div>
              <div>info@m-4.co.kr<br></div>
              <div>서울특별시 성동구 성수이로118<br></div> 
              <div>성수아카데미타워 624호</div>                
              <div class="magnifyBorder ma-3 pa-6" onclick="location.href='tel:070-8844-0621'">                 
                <v-icon color="black darken-3" x-large>mdi-phone-in-talk</v-icon>
                <h2 class="mt-0 mb-n2">070-8844-0621</h2>
                <p class="mt-0 mb-0" style="font-size:12px; color:#888888">AM 10:00 ~ PM 04:30</p>
                <p class="mt-n3 mb-0" style="font-size:12px; color:#888888">fax : 02-6918-0946</p>
              </div>                              
            </div>
            <div id="item-box3"  class="ma-3 pa-3 black--text">
              <img                    
                
                src="../assets/map.png"           
                width="300px"          
                class="img_outline mt-3"
              />                    
            </div>                          
          </v-row>           
        </div>  
        </v-container>  
    </div>

    
    <v-dialog v-model="dialog2" max-width="400px">
      <div @click="close()">
        <v-card class="pa-3" align="center" justify="center">
          <div class="title_sub">트리플 윈</div>
          <div class="mb-3 title_sub">(Win Win Win)</div>
          <img                    
            src="../assets/tripe_win_ko.svg"           
            width="300px"          
          />
          <div class="mt-3">나도 좋고, 너도 좋고, 우리 모두가 좋다.</div>
        </v-card>
        
      </div>
    </v-dialog>


  </div>
</template>


<script>
import axios from "axios";

export default {
	metaInfo: {
    // title 입력하기
    title: '엠포(M4) - AI, RAG, 3D실내지도, IoT 전문기업 | M4 Company',
    // link tag 입력하기
    link: [
      { rel: "canonical", href: 'https://m-4.co.kr/#/ko' },
      { rel: "alternate", hreflang: "ko", href: 'https://m-4.co.kr/#/ko' },
      { rel: "alternate", hreflang: "en", href: 'https://m-4.co.kr/#/en' },
      { rel: "alternate", hreflang: "x-default", href: 'https://m-4.co.kr/#/ko' }
    ],
    // meta tag 입력하기
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { vmid: "description", name: "description", content: '엠포(M4 Company)는 RAG, Fine-Tuning 기술을 기반으로 하이브리드 융합 지식 AI서비스를 제공합니다. 또한 3D실내지도, RTLS, IoT를 활용하여 정밀한 스마트 공간 운영 및 위치 기반 서비스를 구축합니다.' },
      { vmid: "keywords", name: "keywords", content: '엠포, M4, M4 Company, 엠포컴퍼니, AI, RAG, Fine-Tuning, 3D실내지도, 3D Indoor Map, RTLS, IoT, OdyMAP, M.RTLS, M.blockchain, MIND, M4Tarot, EPITAPH, Ticchettio' },
      { vmid: "author", name: "author", content: 'M4 Company' },
      { vmid: "robots", name: "robots", content: 'index, follow' },
      { vmid: "og:type", property: "og:type", content: 'website' },
      { vmid: "og:url", property: "og:url", content: 'https://m-4.co.kr/#/ko' },
      { vmid: "og:title", property: "og:title", content: '엠포(M4) - AI, RAG, 3D실내지도, IoT 전문기업 | M4 Company' },
      { vmid: "og:description", property: "og:description", content: '엠포(M4 Company)는 RAG, Fine-Tuning 기술을 기반으로 하이브리드 융합 지식 AI서비스를 제공합니다. 또한 3D실내지도, RTLS, IoT를 활용하여 정밀한 스마트 공간 운영 및 위치 기반 서비스를 구축합니다.' },
      { vmid: "og:locale", property: "og:locale", content: 'ko_KR' },
      { vmid: "twitter:card", name: "twitter:card", content: 'summary_large_image' },
      { vmid: "twitter:title", name: "twitter:title", content: '엠포(M4) - AI, RAG, 3D실내지도, IoT 전문기업 | M4 Company' },
      { vmid: "twitter:description", name: "twitter:description", content: '엠포(M4 Company)는 RAG, Fine-Tuning 기술을 기반으로 하이브리드 융합 지식 AI서비스를 제공합니다. 또한 3D실내지도, RTLS, IoT를 활용하여 정밀한 스마트 공간 운영 및 위치 기반 서비스를 구축합니다.' }
      //vmid ↑ 메타 태그를 고유하게 만들어준다.
    ]
  },

  data: () => ({ 
    dialog : false,
    dialog2 : false,
    renderForce : false,
    version : "",    
    videoPath : null,    
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },

  },
  mounted () {                
    this.version = localStorage.getItem("Version");
    //console.log('current version :', this.version);  
    
    // 버전업이 되었으면 버전을 올리도록 처리  
    if (process.env.NODE_ENV === 'production') {  
      //console.log('version update check...');  
      //console.log(caches);  
      axios
        .get(`/version.json?timestamp=${new Date().getTime()}`)
        .then(res => {  
        //console.log('server version :', res.data.version);  
        if (res.data.version != this.version) {              
          if (this.version != "") {
            //this.deleteCash();                      
          } 
          localStorage.setItem("Version", res.data.version);                       
        }  
      });  
    }
  },
  methods: {
    OpenImageNewWindow(){
      this.dialog2 = true;
      // const imageUrl = "https://m-4.co.kr/img/tripe_win_ko.svg"; // 여기에 이미지 URL을 입력하세요
      // const imageWidth = 850; // SVG 이미지의 너비
      // const imageHeight = 600; // SVG 이미지의 높이
      // window.open(imageUrl, '_blank', `width=${imageWidth},height=${imageHeight}`);
    },

    close(){
      this.dialog2 = false;
    },

  }
}
</script>

<style scoped>
.header_margin {    
  width:100%;
  height:100px;  
}
/* .header_text {    
  background: #000000;   
} */
.content_get {    
  z-index: 2;
  width:100%;
  float:top;
  background: #FFFFFF;   
}
.content_why {    
  width:100%;  
  background: #2A2A2A;   
}


#content_about {    
  width:80%;    
  line-height:200%;
}

#line-height {
  line-height:200%;
}

#item-box {
  width:300px;
  line-height:200%;
}

#item-box2 {
  width:200px;
  line-height:200%;
}
#item-box3 {
  width:400px;
  line-height:200%;
}



#blinking{
	-webkit-animation:blink 3s ease-in-out infinite alternate;
    -moz-animation:blink 3s ease-in-out infinite alternate;
    animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 


  .magnifyBorder {
    width:240px;
    line-height:200%;
    background: #FFFFFFAA;

    padding: 18px 36px;
    border-radius: 5px;
    box-shadow: inset 0 0 0 0.2px #222222;;
    transition: 300ms box-shadow cubic-bezier(0.4, 0, 0.6, 1), 300ms background-color cubic-bezier(0.4, 0, 0.6, 1), 300ms color cubic-bezier(0.4, 0, 0.6, 1);;
    color: #222222;
  }

  .magnifyBorder:hover {
      background: #FFFFFFE0;
      box-shadow: inset 0 0 0 4px #D6433B;
      color : #222222;
  }


  .class_play_btn{
    z-index: 200;
    position: relative;
    top : 70px;
    height : 0px;
  }

  .video_x_button{
    z-index: 100;
    position: absolute;    
    top : 0px;
    left : 0px;
    height: 25px;
    width : 100%;
    background: #00000000;   
  }

  .circle{
    border-radius: 50%;
    background: #00000010;   
    height : 200px;
    width : 200px;
    text-align: center;
    line-height: 200px;    
    font-size: 40px;
    
  }



#blinking1{
	-webkit-animation:blink 5s ease-in-out infinite alternate;
    -moz-animation:blink 5s ease-in-out infinite alternate;
    animation:blink 5s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 



#blinking2{
	-webkit-animation:blink 6s ease-in-out infinite alternate;
    -moz-animation:blink 6s ease-in-out infinite alternate;
    animation:blink 6s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 

  .title_caption {
    color:#00000030;
    font-weight: 400;
    font-size: 30px;
  }
  .title_header {
    color:#000000C0;
    font-weight: 700;
    font-size: 60px;
  }
  .title_header2 {
    color:#000000C0;
    font-weight: 700;
    font-size: 45px;
  }
  .title_sub {
    color:#000000C0;
    font-weight: 500;
    font-size: 25px;
  }
  .content_header {
    color:#000000C0;
    font-weight: 500;
    font-size: 23px;
  }
  .content_caption {
    color:#000000A0;
    font-weight: 300;
    font-size: 15px;
  }

  .image_title {    
    background: #00000010;
    height : 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    border-radius: 5px;  
  }

  .img_outline {
    border-radius: 10px; /* 모서리 둥글게 */
  }

  /* video[poster]{ 
    height:100%;
    width:100%;
    } */


</style>





<!--  -->